export const pushState = (path: string): void => {
  window.history.pushState(null, '', path)
}
